import $ from "jquery";
import "datatables.net";
import "datatables.net-dt";

export default function initObjectsTable() {
  $(document).ready(function () {
    function init() {
      const table = $(".objects-table").DataTable({
        paging: false,
        aoColumnDefs: [
          { sType: "num", aTargets: [2] },
          { sType: "html", aTargets: [10] },
        ],
        order: [
          [2, "asc"],
          [10, "asc"],
        ],
        drawCallback: function (settings) {
          triggerApartmentsOnImage();
        },
        oLanguage: {
          sZeroRecords: "-",
        },
      });

      table.on("click", "tbody tr", function () {
        // if apartment is not sold
        if ($(this).attr("data-status") !== "2") {
          window.location.href = $(this).attr("data-url");
        }
      });

      const activeBuilding = document.querySelector(`.building-info.active`)
        .dataset["apiId"];

      table.columns(0).search(activeBuilding).draw();
      table.columns(1).search("1").draw();

      // hide maja ID and type columns
      table.columns([0, 1, 7]).visible(false, false);
      table.columns.adjust().draw(false); // adjust column sizing and redraw

      generateFloorFilterValues();
      generateRoomsFilterValues();
      checkAllFilters();

      // ---------------------------------------- //

      function hideColumnsOnMobile() {
        const belowTabletScreen = window.matchMedia("(max-width: 767px)");

        belowTabletScreen.addListener(handleScreenChange);

        function handleScreenChange(e) {
          if (e.matches) {
            // hide balcony, loggia, ceiling height, cooling columns
            // table.columns([6, 7, 8]).visible(false, false);
            table.columns([6, 8, 9]).visible(false, false);
            table.columns.adjust().draw(false); // adjust column sizing and redraw
          } else {
            // show balcony, loggia, ceiling height, cooling columns
            // table.columns([6, 7, 8]).visible(true, true);
            table.columns([6, 8, 9]).visible(true, true);
            table.columns.adjust().draw(false); // adjust column sizing and redraw
          }
        }

        // Run it initially
        handleScreenChange(belowTabletScreen);
      }

      hideColumnsOnMobile();

      // -----------------------------------------//
      function triggerApartmentsOnImage() {
        const tableRows = document.querySelectorAll(".objects-table tbody tr");
        // const tableRows = document.querySelectorAll(
        //   ".objects-table tbody tr[data-object='91']"
        // );

        tableRows.forEach((row) => {
          $(row)
            .off("mouseenter")
            .on("mouseenter", function () {
              const rowID = row.dataset.apartment;
              const apartment = document.querySelector(
                `.int-building[data-apartment=${rowID}]`
              );
              const apartmentParentID = apartment.dataset.parent;
              const buildings = document.querySelectorAll(".int-building-wrap");

              buildings.forEach((item) => {
                if (item.dataset.isParent === apartmentParentID) {
                  item.classList.add("active");

                  setTimeout(function () {
                    item.classList.add("animate-in");
                  }, 10);
                } else {
                  item.classList.remove("active");
                  item.classList.remove("animate-in");
                }
              });

              apartment.classList.add("active");
            });
        });

        tableRows.forEach((row) => {
          $(row)
            .off("mouseleave")
            .on("mouseleave", function () {
              const rowID = row.dataset.apartment;
              const apartment = document.querySelector(
                `.int-building[data-apartment=${rowID}]`
              );

              apartment.classList.remove("active");
            });
        });
      }

      // -----------------------------------------//

      // generate and update floor filter values
      function generateFloorFilterValues() {
        const floorsAll = [];
        table
          .column(3, { search: "applied" })
          .data()
          .each(function (value, index) {
            floorsAll.push(value);
          });

        const floors = [...new Set(floorsAll)].sort((a, b) => a - b);

        const list = document.querySelector(".floors-filter");

        list.innerHTML = "";
        floors.forEach(function (floor) {
          var div = document.createElement("div");
          div.innerHTML = `<input class="filter-item floor-filter" type="radio" id="floor-${floor}" name="floor" value="${floor}"><label for="floor-${floor}">${floor}</label>`;
          list.appendChild(div);
        });
      }

      // generate and update rooms filter values
      function generateRoomsFilterValues() {
        const roomsAll = [];
        table
          .column(4, { search: "applied" })
          .data()
          .each(function (value, index) {
            roomsAll.push(value);
          });

        const rooms = [...new Set(roomsAll)].sort((a, b) => a - b);

        const list = document.querySelector(".rooms-filter");

        list.innerHTML = "";
        rooms.forEach(function (room) {
          var div = document.createElement("div");
          div.innerHTML = `<input class="filter-item room-filter" type="radio" id="room-${room}" name="room" value="${room}"><label for="room-${room}">${room}</label>`;
          list.appendChild(div);
        });
      }

      // -----------------------------------------//

      function clearFloorFilter() {
        table.columns(3).search("").draw();
      }

      function clearRoomFilter() {
        table.columns(4).search("").draw();
      }

      function clearInactiveFilters() {
        const inactives = document.querySelectorAll(".filter-item");
        inactives.forEach((inactive) => {
          if (inactive.classList.contains("inactive")) {
            inactive.classList.remove("inactive");
          }
        });
      }

      function clearObjTypeFilter() {
        // clear object type filter and auto select apartment (1) type
        table.columns(1).search("1").draw();

        // ensure rooms and terrace columns are visible
        // table.columns([4, 6, 7, 8]).visible(true, true);
        // table.columns.adjust().draw(true); // adjust column sizing and redraw

        const belowTabletScreen = window.matchMedia("(max-width: 767px)");

        belowTabletScreen.addListener(handleScreenChange);

        function handleScreenChange(e) {
          if (e.matches) {
            // ensure rooms and terrace columns are visible
            table.columns([4]).visible(true, true);
            table.columns.adjust().draw(false); // adjust column sizing and redraw
          } else {
            // ensure rooms and terrace columns are visible
            // table.columns([4, 6, 7, 8]).visible(true, true);
            table.columns([4, 6, 8]).visible(true, true);
            table.columns.adjust().draw(false); // adjust column sizing and redraw
          }
        }

        // Run it initially
        handleScreenChange(belowTabletScreen);

        // when clearing, add active class to apartment (1) filter
        const typeFilters = document.querySelectorAll(
          ".object-type-filter-item"
        );

        typeFilters.forEach((filter) => {
          if (filter.getAttribute("data-type-id") === "1") {
            filter.classList.add("active");
          } else {
            filter.classList.remove("active");
          }
        });

        // when clearing, make sure "apartment" is the visible table column title
        const typeTableTitles = document.querySelectorAll(".table-title-type");

        typeTableTitles.forEach((title) => {
          if (
            title.getAttribute("data-type-id") === "1" &&
            title.classList.contains("hidden")
          ) {
            title.classList.remove("hidden");
          } else if (
            title.getAttribute("data-type-id") === "2" &&
            !title.classList.contains("hidden")
          ) {
            title.classList.add("hidden");
          }
        });

        const roomFilters = document.querySelector(".rooms-filter-wrap");
        if (roomFilters.classList.contains("hidden")) {
          roomFilters.classList.remove("hidden");
        }
      }

      function hideColumnsOnAripindSelect(filter) {
        if (filter.getAttribute("data-type-id") === "2") {
          // table.columns([4, 6, 7, 8]).visible(false, false);
          // table.columns.adjust().draw(false); // adjust column sizing and redraw

          const belowTabletScreen = window.matchMedia("(max-width: 767px)");

          belowTabletScreen.addListener(handleScreenChange);

          function handleScreenChange(e) {
            if (e.matches) {
              // ensure rooms and terrace columns are visible
              table.columns([4]).visible(false, false);
              table.columns.adjust().draw(false); // adjust column sizing and redraw
            } else {
              // ensure rooms and terrace columns are visible
              // table.columns([4, 6, 7, 8]).visible(false, false);
              table.columns([4, 6, 8]).visible(false, false);
              table.columns.adjust().draw(false); // adjust column sizing and redraw
            }
          }

          // Run it initially
          handleScreenChange(belowTabletScreen);

          const roomFilters = document.querySelector(".rooms-filter-wrap");
          roomFilters.classList.add("hidden");
        }
      }

      function showColumnsOnApartmentSelect(filter) {
        if (filter.getAttribute("data-type-id") === "1") {
          const belowTabletScreen = window.matchMedia("(max-width: 767px)");

          belowTabletScreen.addListener(handleScreenChange);

          function handleScreenChange(e) {
            if (e.matches) {
              // ensure rooms and terrace columns are visible
              table.columns([4]).visible(true, true);
              table.columns.adjust().draw(false); // adjust column sizing and redraw
            } else {
              // ensure rooms and terrace columns are visible
              // table.columns([4, 6, 7, 8]).visible(true, true);
              table.columns([4, 6, 8]).visible(true, true);
              table.columns.adjust().draw(false); // adjust column sizing and redraw
            }
          }

          // Run it initially
          handleScreenChange(belowTabletScreen);

          const roomFilters = document.querySelector(".rooms-filter-wrap");
          if (roomFilters.classList.contains("hidden")) {
            roomFilters.classList.remove("hidden");
          }
        }
      }

      function showActiveFloors() {
        var availFloors = [];
        table
          .column(3, { search: "applied" })
          .data()
          .each(function (value, index) {
            availFloors.push(value);
          });

        const floorFs = document.querySelectorAll(".floor-filter");

        floorFs.forEach((floorF) => {
          const inputValue = floorF.value;

          if (!availFloors.includes(inputValue)) {
            floorF.classList.add("inactive");
          } else {
            floorF.classList.remove("inactive");
          }
        });
      }

      function showActiveRooms() {
        var availRooms = [];
        table
          .column(4, { search: "applied" })
          .data()
          .each(function (value, index) {
            availRooms.push(value);
          });

        const roomFs = document.querySelectorAll(".room-filter");

        roomFs.forEach((roomF) => {
          const inputValue = roomF.value;

          if (!availRooms.includes(inputValue)) {
            roomF.classList.add("inactive");
          } else {
            roomF.classList.remove("inactive");
          }
        });
      }

      // --------------------------------------------- //

      // filter buildings, reset other filters on building change, show active building info
      const buildingFilters = document.querySelectorAll(
        ".svg-building, .header-building-selector, .allveelaeva-trigger, .building-switcher"
      );

      buildingFilters.forEach((filter) => {
        filter.addEventListener("click", function () {
          const buildingID = filter.getAttribute("data-api-id");

          if (buildingID === "91") {
            document.body.classList.remove("obj-155");
            document.body.classList.add("obj-91");
          } else if (buildingID === "155") {
            document.body.classList.remove("obj-91");
            document.body.classList.add("obj-155");
          }

          table.columns(0).search(buildingID, true, false, false).draw(false);

          // URL READ/CHANGE
          const state = { building: buildingID };
          const title = "";
          const url = window.location.href.split("?")[0] + "?obj=" + buildingID;
          history.pushState(state, title, url);
          // URL READ/CHANGE

          clearFloorFilter();
          clearRoomFilter();
          clearObjTypeFilter();

          checkAllFilters();

          generateFloorFilterValues();
          generateRoomsFilterValues();

          const buildingInfos = document.querySelectorAll(".building-info");

          // show active building info on the right
          buildingInfos.forEach((building) => {
            if (building.getAttribute("data-api-id") === `${buildingID}`) {
              building.classList.add("active");
            } else {
              building.classList.remove("active");
            }
          });

          // add active class to active building svg plan image
          const buildings = document.querySelectorAll(".int-building-wrap");

          buildings.forEach((item) => {
            if (item.getAttribute("data-general-id") === buildingID) {
              item.classList.add("active");
              item.classList.add("animate-in");
            } else {
              item.classList.remove("active");
              item.classList.remove("animate-in");
            }
          });

          const buildingTitles = document.querySelectorAll(
            ".building-filter-title"
          );

          // show active building info title in filter window
          buildingTitles.forEach((title) => {
            if (title.getAttribute("data-api-id") === `${buildingID}`) {
              title.classList.add("active");
            } else {
              title.classList.remove("active");
            }
          });

          const buildingTitlesMob = document.querySelectorAll(
            ".building-number-icon"
          );

          // show active building info title in filter window
          buildingTitlesMob.forEach((title) => {
            if (title.getAttribute("data-icon") === `${buildingID}`) {
              title.classList.add("active");
            } else {
              title.classList.remove("active");
            }
          });

          // add active class to clicked building
          buildingFilters.forEach((filter) => {
            filter.classList.remove("active");
          });

          filter.classList.add("active");
        });
      });

      // filter object type
      const typeFilters = document.querySelectorAll(".object-type-filter-item");

      typeFilters.forEach((filter) => {
        filter.addEventListener("click", function () {
          const typeID = filter.getAttribute("data-type-id");

          table.columns(1).search(typeID, true, false, false).draw(false);

          hideColumnsOnAripindSelect(filter);
          showColumnsOnApartmentSelect(filter);

          clearFloorFilter();
          clearRoomFilter();
          checkAllFilters();

          generateFloorFilterValues();
          generateRoomsFilterValues();

          // add active class to clicked type filter
          typeFilters.forEach((filter) => {
            filter.classList.remove("active");
          });

          filter.classList.add("active");

          // highlight "apartment" or "comm space" table title
          const tableTypeTitles =
            document.querySelectorAll(".table-title-type");

          tableTypeTitles.forEach((title) => {
            if (title.getAttribute("data-type-id") === `${typeID}`) {
              title.classList.remove("hidden");
            } else {
              title.classList.add("hidden");
            }
          });
        });
      });

      function filterFloor(floors) {
        table.columns(3).search(floors, true, false, false).draw(false);

        showActiveRooms();
      }

      const floorsFilter = document.querySelector(".floors-filter");

      floorsFilter.addEventListener("click", function (e) {
        const item = e.target.closest("div");
        if (item) {
          filterFloor(item.querySelector("input").value);
        }
      });

      function filterRoom(rooms) {
        table.columns(4).search(rooms, true, false, false).draw(false);

        showActiveFloors();
      }

      const roomsFilter = document.querySelector(".rooms-filter");

      roomsFilter.addEventListener("click", function (e) {
        const item = e.target.closest("div");
        if (item) {
          filterRoom(item.querySelector("input").value);
        }
      });

      // filter only available
      const availFilter = document.querySelector(".availability-filter");

      availFilter.addEventListener("click", function () {
        const input = availFilter.querySelector("input");
        if (input.checked) {
          // const regExSearch = "^(?:(?!span).)*$\r?\n?";
          const regExSearch = ".*\\d+.*";
          table.columns(10).search(regExSearch, true, false).draw();
        } else {
          table.columns(10).search("").draw();
        }

        filterFloor();
        filterRoom();
      });

      // filter only balcony
      const balconyFilter = document.querySelector(".balcony-filter");

      balconyFilter.addEventListener("click", function () {
        const input = balconyFilter.querySelector("input");
        if (input.checked) {
          const regExSearch = ".*\\d+.*";
          table.column(6).search(regExSearch, true, false).draw();
        } else {
          table.columns(6).search("").draw();
        }

        filterFloor();
        filterRoom();
      });

      // -----------------------------------------//
      const clearFiltersBtn = document.querySelectorAll(".clear-filter");

      clearFiltersBtn.forEach((btn) => {
        const filter = btn.getAttribute("data-filter");

        btn.addEventListener("click", function () {
          table.columns(filter).search("").draw();

          clearInactiveFilters();
        });
      });

      function checkAllFilters() {
        const filterRadios = document.querySelectorAll(".clear-filter");

        filterRadios.forEach((radio) => {
          radio.querySelector("input").checked = true;
        });
      }

      // clear all filters exept selected building
      function clearAllFilters() {
        const clearBtns = document.querySelectorAll(".clear-all-table-filters");

        const balconyFilter = document
          .querySelector(".balcony-filter")
          .querySelector("input");
        const availFilter = document
          .querySelector(".availability-filter")
          .querySelector("input");

        clearBtns.forEach((btn) => {
          btn.addEventListener("click", function () {
            clearFloorFilter();
            clearRoomFilter();

            checkAllFilters();

            generateFloorFilterValues();
            generateRoomsFilterValues();

            balconyFilter.checked = false;
            table.columns(6).search("").draw();
            availFilter.checked = false;
            table.columns(10).search("").draw();

            const clearBtn = document.querySelector(".clear-table-filters-btn");
            clearBtn.click();
          });
        });
      }

      clearAllFilters();

      function checkActiveFilters() {
        const activeFilters = [];

        function removeFilter(arr, value) {
          var index = arr.indexOf(value);
          if (index > -1) {
            arr.splice(index, 1);
          }
          return arr;
        }

        function showFilterCount() {
          const countDiv = document.querySelector(".active-filters-count span");
          const count = activeFilters.length;

          if (count > 0) {
            countDiv.innerHTML = `${count}`;
            countDiv.parentNode.classList.remove("hidden");
          } else {
            countDiv.parentNode.classList.add("hidden");
          }
        }

        const clearBtn = document.querySelector(".clear-table-filters-btn");

        function toggleFilterOptions() {
          if (activeFilters.length === 0) {
            clearBtn.classList.add("hidden");
          } else {
            clearBtn.classList.remove("hidden");
          }
        }

        clearBtn.addEventListener("click", function () {
          clearBtn.classList.add("hidden");
          clearFloorFilter();
          clearRoomFilter();

          checkAllFilters();
          clearInactiveFilters();

          const balconyFilter = document
            .querySelector(".balcony-filter")
            .querySelector("input");
          const availFilter = document
            .querySelector(".availability-filter")
            .querySelector("input");

          balconyFilter.checked = false;
          table.columns(6).search("").draw();
          availFilter.checked = false;
          table.columns(10).search("").draw();

          activeFilters.splice(0, activeFilters.length);

          showFilterCount();
        });

        function floorFilters() {
          const floorFilters = document.querySelectorAll(".floor-filter");
          const clearFloors = document.querySelector("#floor-all");

          floorFilters.forEach((filter) => {
            filter.addEventListener("click", function () {
              if (filter.checked && !activeFilters.includes("floors")) {
                activeFilters.push("floors");

                toggleFilterOptions();
                showFilterCount();
              }
            });
          });

          clearFloors.addEventListener("click", function () {
            if (clearFloors.checked && activeFilters.includes("floors")) {
              removeFilter(activeFilters, "floors");

              toggleFilterOptions();
              showFilterCount();
            }
          });
        }

        function roomFilters() {
          const roomFilters = document.querySelectorAll(".room-filter");
          const clearRooms = document.querySelector("#room-all");

          roomFilters.forEach((filter) => {
            filter.addEventListener("click", function () {
              if (filter.checked && !activeFilters.includes("rooms")) {
                activeFilters.push("rooms");

                toggleFilterOptions();
                showFilterCount();
              }
            });
          });

          clearRooms.addEventListener("click", function () {
            if (clearRooms.checked && activeFilters.includes("rooms")) {
              removeFilter(activeFilters, "rooms");

              toggleFilterOptions();
              showFilterCount();
            }
          });
        }

        function availFilters() {
          const availFilter = document.querySelector(
            ".availability-filter input"
          );

          availFilter.addEventListener("click", function () {
            if (availFilter.checked && !activeFilters.includes("avail")) {
              activeFilters.push("avail");
              toggleFilterOptions();
              showFilterCount();
            } else {
              removeFilter(activeFilters, "avail");
              toggleFilterOptions();
              showFilterCount();
            }
          });
        }

        function balconyFilters() {
          const balconyFilter = document.querySelector(".balcony-filter input");

          balconyFilter.addEventListener("click", function () {
            if (balconyFilter.checked && !activeFilters.includes("balcony")) {
              activeFilters.push("balcony");
              toggleFilterOptions();
              showFilterCount();
            } else {
              removeFilter(activeFilters, "balcony");
              toggleFilterOptions();
              showFilterCount();
            }
          });
        }

        floorFilters();
        roomFilters();
        availFilters();
        balconyFilters();
      }

      checkActiveFilters();

      // move table filters outside of content on smaller screens
      function moveMobileFilters() {
        const desktopTableWrap = document.querySelector(".table-filters-wrap");
        const desktopBuildingWrap = document.querySelector(".object-filters");

        const desktopTable = document.querySelector(".table-filters-details");
        const mobileTable = document.querySelector(
          ".table-filters-details-mobile-wrap"
        );

        // const desktopFilterWindow = document.querySelector(
        //   ".building-filter-window"
        // );
        // const mobileFilterWindow = document.querySelector(
        //   ".building-filter-window-mobile-wrap"
        // );

        const mobileScreen = window.matchMedia("(max-width: 1149px)");

        mobileScreen.addListener(handleScreenChange);

        function handleScreenChange(e) {
          if (e.matches) {
            mobileTable.appendChild(desktopTable);
            // mobileFilterWindow.appendChild(desktopFilterWindow);
          } else {
            if (!desktopTableWrap.contains(desktopTable)) {
              desktopTableWrap.appendChild(desktopTable);
            }

            // if (!desktopBuildingWrap.contains(desktopFilterWindow)) {
            //   desktopBuildingWrap.appendChild(desktopFilterWindow);
            // }
          }
        }

        // Run it initially
        handleScreenChange(mobileScreen);
      }

      moveMobileFilters();

      // triggering functions when clicking header filters
      const headerTypeFilters = document.querySelectorAll(
        ".header-type-filter-item"
      );

      headerTypeFilters.forEach((filterH) => {
        filterH.addEventListener("click", function () {
          const filterTypeValue = filterH.getAttribute("data-type-id");
          const filterObjectValue = filterH.getAttribute("data-api-id");

          document
            .querySelector(
              `.object-type-filter-item[data-type-id="${filterTypeValue}"][data-building-id="${filterObjectValue}"]`
            )
            .click();

          const svgBuildings = document.querySelectorAll(".svg-building");

          svgBuildings.forEach((building) => {
            if (building.classList.contains("active")) {
              building.classList.remove("active");
            }
          });

          const activeBuilding = document.querySelector(
            `.svg-building[data-api-id="${filterObjectValue}"]`
          );

          // activeBuilding.classList.add("active");
        });
      });

      function autoSlideHeader() {
        const mobileScreen = window.matchMedia("(max-width: 1023px)");

        mobileScreen.addListener(handleScreenChange);

        function handleScreenChange(e) {
          if (e.matches) {
            const pricesHeaderWrap = document.querySelector(
              ".prices-header-wrap"
            );

            setTimeout(function () {
              const distance = pricesHeaderWrap.scrollWidth - 620;
              pricesHeaderWrap.scrollLeft = distance;
              console.log(distance);
            }, 10);
          }
        }

        // Run it initially
        handleScreenChange(mobileScreen);
      }

      // autoSlideHeader();

      function triggerModalFromApartmentSVG() {
        const items = document.querySelectorAll(".int-building");

        items.forEach((item) => {
          item.addEventListener("click", function () {
            const id = item.getAttribute("data-apartment");
            const tableRow = document.querySelector(`tr[data-apartment=${id}]`);

            if (tableRow !== null) {
              tableRow.click();
            }
          });
        });
      }

      triggerModalFromApartmentSVG();
    }

    const isPresent = document.getElementsByClassName("objects-table");
    if (isPresent.length > 0) {
      init();
    }
  });
}
